import React, { lazy, Suspense } from "react";
import BannerSection from "../components/BannerSection";
import VerificationBackend from "../components/VerificationBackend";
import ProductsFooter from "../components/ProductsFooter";
import TextCarosul from "../components/TextCarosul";
import IDProofFAQS from "../components/IDProofFAQS";

const ThreeSixtyView = lazy(() => import("../components/ThreeSixtyView"));

const IDProof = () => {
  return (
    <>
      <BannerSection />
      <Suspense fallback={<div>loading...</div>}>
        <ThreeSixtyView />
      </Suspense>
      <Suspense>
        <VerificationBackend />
      </Suspense>
      <IDProofFAQS />
      <TextCarosul />
      <ProductsFooter />
    </>
  );
};

export default IDProof;
